import aspectDropdownData from '@anm/data/video-templates/aspect-dropdown';
import { FC } from 'react';

import DropdownItem from './DropdownItem';
import { DropdownContentWrapper } from './Wrapper';
import { DropdownCommonProps } from './types';

export const DropdownContent: FC<DropdownCommonProps> = props => (
  <DropdownContentWrapper>
    {aspectDropdownData.map((item, index) => (
      <DropdownItem key={item.title} {...{ index, ...item, ...props }} />
    ))}
  </DropdownContentWrapper>
);
